import {
  getOperatorFromQueryFilter,
  getOperatorFromSimpleFilter,
  getValueFromQueryFilter,
  getValueFromSimpleFilter,
} from '@/sections/insights/queryBuilder/entities/common/translators';
import type {
  SimpleFilter,
  SimpleFilterDefinition,
} from '@/sections/insights/queryBuilder/entities/types';
import type { QueryFilter } from '@/types';

/**
 * Factory function for creating boolean SimpleFilterDefinitions
 * Eliminates duplication across boolean fields with Yes/No dropdowns
 *
 * @param apiField - Backend field name (e.g., 'isaclprotected')
 * @param uiField - UI display name (e.g., 'ACL Protected')
 * @returns Complete SimpleFilterDefinition with boolean translation logic
 */
export function createBooleanSimpleFilterDefinition(
  apiField: string,
  uiField: string
): SimpleFilterDefinition {
  return {
    apiField,
    uiField,
    inputType: 'dropdown',
    getAvailableValues: () => Promise.resolve(['Yes', 'No']),
    operators: ['is', 'is not'],

    translateForUI: (queryFilter: QueryFilter): SimpleFilter => {
      const valueMap: Record<string, string> = {
        true: 'Yes',
        false: 'No',
      };

      return {
        field: uiField,
        operator: getOperatorFromQueryFilter(queryFilter),
        value: getValueFromQueryFilter(valueMap, queryFilter),
      };
    },

    translateForAPI: (simpleFilter: SimpleFilter): QueryFilter => {
      const valueMap: Record<string, boolean> = {
        Yes: true,
        No: false,
      };

      return {
        field: apiField,
        operator: getOperatorFromSimpleFilter(simpleFilter),
        value: getValueFromSimpleFilter(valueMap, simpleFilter),
      };
    },
  };
}
